import React, { Component } from "react";

const Style = {
  contentCss: {
    WebkitLineClamp: 3
  },
  indentation: {
    marginRight: "5px"
  }
};

class ReadMore extends Component {
  state = {};

  readMore = () => {
    this.setState(prevState => ({
      readMore: !prevState.readMore
    }));
  };

  render() {
    const {
      tag,
      content = "",
      length,
      text,
      handleReadMore,
      height,
      classes = "",
      indentation = ""
    } = this.props;
    const { readMore } = this.state;
    const readMoreTag = tag || (
      <span>{text ? text : readMore ? " .Read Less" : "...Read More"}</span>
    );

    // check if length
    const defaultLength =
      length || (typeof content === "string" && content.length) || 200;
    return (
      <div
        className={classes}
        style={{
          ...Style.contentCss,
          height: !readMore ? height + "px" : "auto",
          overflow:
            !readMore || content.match(/[\u0900-\u097F]/) ? "hidden" : "auto"
        }}
      >
        {indentation ? (
          <span style={Style.indentation}>{indentation}</span>
        ) : null}
        <span
          className={`${
            content.match(/[\u0900-\u097F]/) ? "hindi-text-no-weight" : ""
          }`}
        >
          {(!readMore && content.substring(0, defaultLength)) || content}
        </span>
        <span
          className="read-more"
          onClick={handleReadMore ? handleReadMore : null}
        >
          {(content.length > defaultLength &&
            (tag ? tag : <span onClick={this.readMore}>{readMoreTag}</span>)) ||
            null}
        </span>
      </div>
    );
  }
}

export default ReadMore;
